import { flatMap, get, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
import api from "../../apis/axiosInterceptor";
import { HTTPS } from "../../shared/constants";

interface MasterQuestion {
  masterQuestionData: object;
  curmasterQuestionEditData: any;
  totalPageCount: number;
  totalData: number;
  error: string;
}

const initialArgs: MasterQuestion = {
  masterQuestionData: [],
  curmasterQuestionEditData: {},
  totalPageCount: 0,
  totalData: 17,
  error: "",
};

const reducer = (state: MasterQuestion, action: MasterQuestion) => {
  return { ...state, ...action };
};

const useMasterQuestion = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getMasterQuestion = async (
    page: string,
    listPerPage: string,
    searchText: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/v1/masterQuestionJobPost?page=${page}&listPerPage=${listPerPage}&search=${searchText}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          masterQuestionData: result.data.data.data,
          totalPageCount: get(result, "data.data.totalPageCount", 0),
          totalData: get(result, "data.data.totalData", 0),
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createMasterQuestion = async (param: any) => {
    const paramObj = {
      ...param,
    };
    try {
      const result: any = await api.post(
        "/api/v1/masterQuestionJobPost",
        paramObj,
      );

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Master Question has been Added Successfully");
        setState({ ...state, masterQuestionData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //Edit
  const editMasterQuestion = async (questionariesId: string) => {
    try {
      const result: any = await api.get(
        `/api/v1/masterQuestionJobPost/${questionariesId}`,
      );

      if (result.data.status) {
        setState({ ...state, curmasterQuestionEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //For Update
  const updateQuestion = async (param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.post(
        `/api/v1/masterQuestionJobPost/${param.id}`,
        paramObj,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const deleteMasterQuestion = async (questionariesId: number) => {
    try {
      const { status } = await api.delete(
        `/api/v1/masterQuestionJobPost/delete?id=${questionariesId}`,
      );

      if (status === HTTPS.OK) {
        toast.success("Master Question has been deleted successfully");
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      toast.error("Error while deleting Master Question");
      return false;
    }
  };
  return {
    getMasterQuestion,
    createMasterQuestion,
    editMasterQuestion,
    updateQuestion,
    deleteMasterQuestion,
    ...state,
  };
};

export default useMasterQuestion;
